<!------------------------------------->
<!-- List tab detail layout.
 * File Name ..: agencysettings.component.html
 * Generated by: ianday
 * Date .......: 10/10/23
--------------------------------------->
<div class="agencysettings-form-container">
    <div class="query-strip-container mat-elevation-z2">
        <table height="100%">
            <TR>
                <TD class="table-title-cell">
                    <i class="fa fa-medkit fa-fw table-icon-header"
                       style="width: 2em"></i>{{formTitle}}
                </TD>

                <TD align="left" style="min-width: 400px;">
                    <input text id="txtFilter" #txtFilter
                           matTooltip="Type to match data in all columns except date fields"
                           class="qs_filter-field" [disabled]="this.isEditing"
                           (keyup)="applyFilter($event.target.value)" placeholder="<Filter>">
                    <button mat-button matSuffix mat-icon-button
                            matTooltip="Clear the filter" aria-label="Clear"
                            (click)="txtFilter.value=''; clearFilter();">
                        <mat-icon>close</mat-icon>
                    </button>
                </TD>
                <TD class="qs-label-cell" style="width: 60px; text-align: center;">Status:</TD>
                <TD style="width: 150px">
                    <dw-dropdown 
                     [useStatusOptions]="'all'"
                     [selectedItem]="selectedStatusFilter"
                     [controlWidth]="'120px'"
                     (itemSelected)="selectedStatusFilter = $event; txtFilter.value=''; onChangeStatusFilterValue()">
                    </dw-dropdown>
                </TD>
                <TD class="table-pagination-cell" align="right">{{pagination}} Record(s) ...</TD>
            </TR>
        </table>
    </div>

        <div class="main-client-area">
            <!--------------------------->
            <!-- RECORDS TABLE         -->
            <!--------------------------->
            <div #tb1 [ngClass]="contentClassName" class="table-container mat-elevation-z1"
                 (keydown)="tableKeyDown($event)" tabindex="-1">
                <table mat-table [dataSource]="dataSource" matSort
                       (matSortChange)="onSortChange($event)">

                    <!--- Note that these columns can be defined in any order.
                  The actual rendered columns are set as a property on
                  the row definition" -->

                    <!-- Position Column -->
                    <ng-container matColumnDef="id" >
                        <th mat-header-cell *matHeaderCellDef  mat-sort-header
                            style="background-color: white; z-index:99999">Id
                        </th>
                        <td mat-cell style="width:8% !important;"
                            *matCellDef="let element;let tableRowIdx = index;">
                            {{element.id}}</td>
                    </ng-container>

                    <ng-container matColumnDef="agencyName" >
                        <th mat-header-cell *matHeaderCellDef mat-sort-header
                            style="background-color: white; z-index:99999">Agency Name
                        </th>
                        <td mat-cell style="width: 20% !important;"
                            *matCellDef="let element">{{element.agencyName}}</td>
                    </ng-container>

                    <ng-container matColumnDef="primaryContact" >
                        <th mat-header-cell *matHeaderCellDef mat-sort-header
                            style="background-color: white; z-index:99999">Primary Contact
                        </th>
                        <td mat-cell style="width:20%!important;"
                            *matCellDef="let element">{{element.primaryContact}}</td>
                    </ng-container>

                    <ng-container matColumnDef="phoneNumber" >
                        <th mat-header-cell *matHeaderCellDef mat-sort-header
                            style="background-color: white; z-index:99999">Phone Number
                        </th>
                        <td mat-cell style="width: 15%;"
                            *matCellDef="let element">{{element.phoneNumber}}</td>
                    </ng-container>

                    <ng-container matColumnDef="emailAddress" >
                        <th mat-header-cell *matHeaderCellDef mat-sort-header
                            style="background-color: white; z-index:99999">Email Address
                        </th>
                        <td mat-cell style="width:25% !important;"
                            *matCellDef="let element">{{element.emailAddress}}</td>
                    </ng-container>

                    <ng-container matColumnDef="activeStatus"  style="width: 15% !important;">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header
                            style="background-color: white; z-index:99999">Status
                        </th>
                        <td mat-cell *matCellDef="let element" >
                            <dw-dropdown *ngIf="selectedRecord?.id == element.id"
                                [disabled]="isEditing || !visibleModify"
                                [useStatusOptions]="'status'"
                                [selectedItem]="element.activeStatus"
                                [controlWidth]="'120px'"
                                (itemSelected)="element.activeStatus = $event; onStatusChange()">
                            </dw-dropdown>

                            <span *ngIf="selectedRecord?.id !== element.id"
                                  style="padding-left: 3px;">{{element.activeStatus}}</span>
                        </td>
                    </ng-container>




                    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                    <tr mat-row
                        *matRowDef="let row; columns: displayedColumns; let tableRowIdx = index;"
                        [ngClass]="{'row-selected': tableRowIdx == Idx}"
                        (click)="onRowClicked(row)">
                    </tr>
                </table>
            </div>
            <!-------------------------------------->
            <!-- Control Strip                    -->
            <!-------------------------------------->
            <div class="mat-elevation-z2 control-strip">
                <button *ngIf="visibleAdd" mat-button [disabled]="this.isEditing"
                        matTooltipPosition="above"
                        class="command-button" matTooltip="Add a new record"
                        (click)="addModifyRecord(true)" mat-button>
                    <mat-icon>add_circle_outline</mat-icon>
                    Add New
                </button>
                <button *ngIf="visibleModify" mat-button class="command-button"
                        matTooltipPosition="above"
                        style="margin-top: 5px;" [disabled]="(Idx < 0|| this.isEditing)"
                        matTooltip="Edit a selected record" (click)="addModifyRecord(false)"
                        mat-button>
                    <mat-icon>edit</mat-icon>
                    Edit
                </button>
                <button *ngIf="visibleDelete" mat-button class="command-button"
                        matTooltipPosition="above"
                        style="margin-top: 5px;" [disabled]="(Idx < 0 || this.isEditing)"
                        matTooltip="Remove a selected record" (click)="removeRecord()"
                        mat-button>
                    <mat-icon>remove_circle_outline</mat-icon>
                    Remove
                </button>
            </div>
            <!------------------------------->
            <!--  Detail panel             -->
            <!------------------------------->
            <div id="agencysettings-details-panel" class="agencysettings-detail-container mat-elevation-z2"
                 style="margin-bottom: 2px;">
                <mat-tab-group animationDuration="0ms" (selectedTabChange)="doTabChange($event)"
                               [(selectedIndex)]=selectedTabIndex>
                    <mat-tab label="Details" [disabled]="isEditing">
                        <div class="sub-tab-container-class detail-tab-additional">
                            <div class="dwform" style="padding-right: 15px;">

                                <div class="dwform-cell-nopadding" style="min-width: 500px;">

                                    <div class="dwform-row-double-gap"></div>
                                    <div class="dwform-row">

                                        <label class="label-field">ID:</label> <span
                                           class="form-required"> </span>
                                        <input class="input-field-short" id="agencyId" style="width:80px"
                                               disabled="true"
                                               [(ngModel)]="id"
                                               type="text">

                                    </div>

                                    <div class="dwform-row-gap"></div>

                                    <div class="dwform-row">

                                    <label class="label-field">Agency Name:</label>
                                    <span class="form-required">*</span>
                                    <input class="input-field-longest" id="agencyName" [disabled]="!isEditing"
                                           style="text-transform: capitalize"
                                           [(ngModel)]="agencyName"
                                           placeholder="<Agency Name>"
                                           type="text">

                                     <div class="dwform-row-gap"></div>

                                        <label class="label-field">Address:</label>
                                        <span class="form-required">*</span>
                                        <input class="input-field-longest" id="address1" [disabled]="!isEditing"
                                               [(ngModel)]="address1"
                                               style="text-transform: capitalize"
                                               placeholder="<Address line 1>"
                                               type="text">

                                        <div class="dwform-row-gap"></div>

                                        <label class="label-field"></label>
                                        <span class="form-required"></span>
                                        <input class="input-field-longest" id="address2" [disabled]="!isEditing"
                                               [(ngModel)]="address2"
                                               style="text-transform: capitalize"
                                               type="text">

                                        <div class="dwform-row-gap"></div>

                                        <label class="label-field"></label>
                                        <span class="form-required"></span>
                                        <input class="input-field" id="city"
                                               style="width: 260px;text-transform: capitalize"
                                               [disabled]="!isEditing"
                                               [(ngModel)]="city"
                                               placeholder="<City>"
                                               type="text">

                                        <input class="input-field-shortest" id="state"
                                               style="width:30px;text-transform: uppercase"
                                               [disabled]="!isEditing"
                                               [(ngModel)]="state"
                                               placeholder=""
                                               type="text">

                                        <input class="input-field-shortest" id="zipCode" [disabled]="!isEditing"
                                               [(ngModel)]="zipCode" style="width: 85px"
                                               placeholder="<Zip>"
                                               type="text">

                                        <div class="dwform-row-gap"></div>

                                        <label class="label-field">County:</label>
                                        <span class="form-required"> </span>
                                        <input class="input-field" [disabled]="!isEditing" id="county"
                                               style="text-transform: capitalize"
                                               [(ngModel)]="county"
                                               placeholder="<County>"
                                               type="text">

                                        <div class="dwform-cell " style="min-width: 520px;padding-left: 30px;">

                                            <label class="label-field">Status:</label>
                                            <span class="form-required">*</span>

                                            <dw-dropdown
                                                id="activeStatusId"
                                                [disabled]="!isEditing"
                                                [selectedItem]="activeStatus"
                                                (itemSelected)="activeStatus = $event"
                                                [controlWidth]="'120px'" [useStatusOptions]="'status'">
                                            </dw-dropdown>

                                            <div class="dwform-row-gap"></div>

                                            <label class="label-field">Primary Contact: </label>
                                            <span class="form-required">*</span>
                                            <input class="input-field" [disabled]="!isEditing" id="primaryContact"
                                                   style="text-transform: capitalize"
                                                   [(ngModel)]="primaryContact"
                                                   placeholder="<Primary Contact>"
                                                   type="text">

                                            <div class="dwform-row-gap"></div>

                                            <label class="label-field">Telephone: </label>
                                            <span class="form-required">*</span>

                                            <p-inputMask matInput class="input-field" id="phoneNumber"
                                                         [disabled]="!isEditing"
                                                         mask="(999) 999-9999"
                                                         [(ngModel)]="phoneNumber" placeholder="<Telephone>"
                                                         type="text">
                                            </p-inputMask>

                                            <div class="dwform-row-gap"></div>

                                            <label class="label-field">Email: </label>
                                            <span class="form-required">*</span>
                                            <input class="input-field" [disabled]="!isEditing" id="emailAddress"
                                                   [(ngModel)]="emailAddress"
                                                   placeholder="<Email Address>"
                                                   type="text">
                                        </div>

                                    </div>
                                </div>
                                <!----------------------->
                                <!-- ERROR LINE --------->
                                <!----------------------->
                                <div class="error-line" [hidden]='!strErr.length'
                                     style="text-align:left">{{strErr}}</div>
                                <!----------------------->
                                <!-- SAVE STRIP        -->
                                <!----------------------->
                                <div class="save-close-strip" style="bottom: 3px;">

                                    <button mat-button class="command-button" *ngIf="this.isEditing"
                                            (click)="submitRecord()" matTooltip="Save the record"
                                            mat-button>
                                        <mat-icon>check_circle_outline</mat-icon>
                                        Submit
                                    </button>
                                    <button mat-button class="command-button" *ngIf="this.isEditing"
                                            (click)="cancelSubmitRecord()" matTooltip="Cancel edits" mat-button>
                                        <mat-icon>highlight_off</mat-icon>
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </div>
                    </mat-tab>
                    <mat-tab label="History" [disabled]="isEditing">
                        <div class="sub-tab-container-class detail-tab-additional">
                            <transaction-history #history></transaction-history>
                        </div>
                    </mat-tab>
                </mat-tab-group>
            </div>
        </div>
   </div>

